import React from 'react';
import Img from 'gatsby-image';
import { isNullOrUndefined } from 'util';
import Styles from 'components/Styles';
import Video from 'components/Video';

import { WebsiteImageContainer, StyledImage } from './styles';

const WebsiteImage = props => {
  const {
    src,
    alt,
    boxShadow,
    className,
    imageStyles,
    styles,
    width,
    maxWidth,
    imageSizes,
    imgStyle,
    widthMobile,
    widthDesktop,
  } = props;
  const { marginMobile, marginDesktop, paddingMobile, paddingDesktop } = styles || {};
  const imageRatio = imageSizes?.width / imageSizes?.height;

  if (!isNullOrUndefined(src) && src !== '') {
    const style = {
      ...imgStyle,
      maxWidth: maxWidth,
    };
    if (src?.fluid?.src) {
      return (
        <Styles {...styles}>
          <WebsiteImageContainer
            widthMobile={widthMobile}
            widthDesktop={widthDesktop}
            imageSizes={imageSizes}
            boxShadow={boxShadow}
          >
            <Img
              fluid={src?.fluid}
              alt={alt || 'Product Illustration'}
              imgStyle={style}
              className={className}
              style={style}
            />
          </WebsiteImageContainer>
        </Styles>
      );
    } else if (src?.file?.contentType === 'video/mp4') {
      return (
        <Video
          boxShadow={boxShadow}
          type="preview-only"
          mainSrc={src?.file?.url}
          previewSrc={src?.file?.url}
        />
      );
    } else {
      const source = src?.file?.url || src;

      return (
        <StyledImage
          src={source}
          alt={alt || 'Product Illustration'}
          marginMobile={marginMobile}
          marginDesktop={marginDesktop}
          widthMobile={widthMobile}
          widthDesktop={widthDesktop}
          className={className}
        />
      );
    }
  } else {
    return null;
  }
};

export default WebsiteImage;
